module.exports = __webpack_public_path__ + "img/liotron_200ah.0841693f.png";